/**
 * Tarifas Bancárias Pix
 * (prototype: erpone_tarifas_banc_rias_pix)
 *
 * Contrato: GET /finance/bank-tariffs?channel=PIX → PaginatedResponseDto<BankTariffResponseDto>
 */
import { BankTariffsChannelPage } from './BankTariffsChannelPage';

export function BankTariffsPixPage(): JSX.Element {
  return (
    <BankTariffsChannelPage
      channel="PIX"
      title="Tarifas Bancárias — Pix"
      subtitle="Tarifas por serviço/evento do Pix (cobrança, liquidação...)."
    />
  );
}